import React from "react";
import parse from 'html-react-parser';
import usePrivacyPolicy from "hooks/usePrivacyPolicy";

import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  const { policyData } = usePrivacyPolicy();

  return (
    <section className="terms-page">
      <Container>
        {parse(policyData?.description || "")}
      </Container>
    </section>
  );
};

export default PrivacyPolicy;
